import { render } from "./HiddenText.vue?vue&type=template&id=6076569a&scoped=true"
import script from "./HiddenText.vue?vue&type=script&lang=js"
export * from "./HiddenText.vue?vue&type=script&lang=js"

import "./HiddenText.vue?vue&type=style&index=0&id=6076569a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6076569a"]])

export default __exports__